import React from 'react';
import type { ValuePropRowProps } from './types';

/** One icon + label row of the onboarding capabilities list (screen 2). */
export const ValuePropRow: React.FC<ValuePropRowProps> = ({ icon, label, secondary, disabled, last }) => (
    <div className={`flex items-center gap-m py-m ${last ? '' : 'border-b border-line-subtle'}`}>
        <span className={`flex items-center justify-center w-8 h-8 rounded-full shrink-0 bg-surface-secondary ${disabled ? 'text-content-tertiary' : 'text-icon'}`}>
            {icon}
        </span>
        <div className="flex flex-col">
            <span className={`text-body ${disabled ? 'text-content-tertiary' : 'text-content'}`}>{label}</span>
            {secondary && <span className="text-s text-content-tertiary">{secondary}</span>}
        </div>
    </div>
);
